import { useEffect, useState } from "react";
import { enterGetHoldMode } from "src/Slicers/eQueue/EnterThunks";
import { FeedbackMessage, InputNumber } from "src/Components/Controls";
import { IconButton, Modal, UTextList } from "src/Components";
import { Headline } from "src/UI";
import { useAppDispatch } from "src/Hooks";
import { IModalProps } from "..";
import { EQueueType } from "src/Types/ReDoc/EQueue";
import "../modals.scss";

interface IPostponeModalProps extends IModalProps {};

/**
 * Модальное окно откладывания приема посетителя
 * Позволяет отложить прием на определенное время или сразу
 */
const PostponeModal: React.FC<IPostponeModalProps> = ( { type, isOpen, onClose, onAction } ) => {

	const dispatch = useAppDispatch();
	const [ holdMode, setHoldMode ] = useState<number>(0);
	const [ delay, setDelay ] = useState<number|null>(null);

	/** Загружает режим откладывания для Enter очереди */
	useEffect( () => {
		if ( type === EQueueType.Enter ) {
			dispatch ( enterGetHoldMode() ).unwrap()
				.then( data => !data.hasError && setHoldMode( data.result ) );
		}
	}, [] );

	/**
	 * Валидирует введенное время откладывания
	 * Проверяет обязательность поля, минимальное и максимальное значения
	 */
	const validateDelay = (value: number|null): string => {
		switch (true) {
			case !value:
				return "Обязательное поле";
			case value! < 0:
				return "Значение не может быть меньше нуля";
			case value! > 480:
				return "Нельзя отложить на более 480 минут";
			default:
				return '';
		}
	};

	const withTime = type === EQueueType.Damask || holdMode === 1;
	const errorMsg = withTime ? validateDelay(delay) : '';

	/**
	 * Рендерит содержимое модального окна
	 * Показывает поле ввода времени только для Damask или когда holdMode === 1
	 */
	const renderBody: React.FC = ( props ) => {
		if ( withTime ) {
			return (
				<div className="modal_wrapper modal_wrapper-postpone">
					<Headline>На сколько отложить прием посетителя?</Headline>
					<InputNumber value={delay} onChangeValue={setDelay} placeholder="Введите количество минут" />
					{ !!errorMsg && <FeedbackMessage message={errorMsg} /> }
					<UTextList splitBy=';'>
						До истечения указанного времени Вы сможете вызвать посетителя из персональной очереди.;
						После истечения указанного времени Вы сможете вызвать посетителя при приглашении следующего.
					</UTextList>
				</div>
			);
		}
		return (
			<div className="modal_wrapper modal_wrapper-postpone">
				<Headline>Отложить прием посетителя?</Headline>
			</div>
		);
	};

	/** Рендерит панель инструментов модального окна */
    const renderModalToolbar = () => {
		return (
			<>
				<IconButton outline onClick={onClose}>Закрыть</IconButton>
				<IconButton disable={ withTime && !!errorMsg} onClick={ () => onAction('delay', delay )} >Отложить</IconButton> 
			</>
		)
	};

    return (
        <Modal
			isOpen={isOpen}
			title="Отложить прием посетителя"
			onClose={onClose}
			color="light"
			renderFooter={renderModalToolbar()}
			renderBody={renderBody}
		/>
    );
};

export default PostponeModal;
